// extracted by mini-css-extract-plugin
export default {"root":"root___n8V0a","clear":"clear___RNvNT","icon":"icon___XNTN5"};